import { word } from "@/modules/core/utils/i18n"

export enum ScoreType {
  REPS = "REPS",
  ROUND_AND_REPETITIONS = "ROUNDS_AND_REPS",
  WEIGHT = "WEIGHT",
  TIME = "TIME",
  CALORIES = "CALORIES",
  DISTANCE = "DISTANCE",
  NO_SCORE = "NO_SCORE",
  WATTS = "WATTS",
  TEXT_FROM_ATHLETE = "TEXT_FROM_ATHLETE",
}

export enum ScoreResultType {
  TOTAL = "TOTAL",
  HIGHEST = "HIGHEST",
  LOWEST = "LOWEST",
  AVERAGE = "AVERAGE",
  SET_N_FOR_SCOREBOARD = "SET_N_FOR_SCOREBOARD",
}

export enum ScoreDifficultyEnum {
  RX = "RX",
  INTERMEDIATE = "INTERMEDIATE",
  MASTER_PLUS_55 = "MASTER_PLUS_55",
  BEGINNER = "BEGINNER",
}

export enum ScoreDifficultyFilterEnum {
  ALL = "ALL",
  RX = "RX",
  INTERMEDIATE = "INTERMEDIATE",
  MASTER_PLUS_55 = "MASTER_PLUS_55",
  BEGINNER = "BEGINNER",
}

export type TieBreak = {
  time: number | null
  threshold: number
}

// Wording for the difficulties. Those are not meant to be translated.
export const getScoreDifficultyWording = (difficulty: ScoreDifficultyFilterEnum | ScoreDifficultyEnum) => {
  switch (difficulty) {
    case ScoreDifficultyFilterEnum.ALL:
      return word("scoreboard.filters.all")
    case ScoreDifficultyFilterEnum.RX || ScoreDifficultyEnum.RX:
      return "RX"
    case ScoreDifficultyFilterEnum.INTERMEDIATE || ScoreDifficultyEnum.INTERMEDIATE:
      return "Intermediate"
    case ScoreDifficultyFilterEnum.MASTER_PLUS_55 || ScoreDifficultyEnum.MASTER_PLUS_55:
      return "Master +55"
    case ScoreDifficultyFilterEnum.BEGINNER || ScoreDifficultyEnum.BEGINNER:
      return "Beginner"
    default:
      return ""
  }
}

export type ScoreResultDraftType =
  | ScoreResultType.TOTAL
  | ScoreResultType.HIGHEST
  | ScoreResultType.LOWEST
  | ScoreResultType.AVERAGE
  | `SET_N_FOR_SCOREBOARD_${string}`

export type ScoreSetConfigurationFormikType = {
  id: string | null
  displayOrder: number
  scoreType: ScoreType
}

export type ScoreSetConfiguration = {
  id: string
  displayOrder: number
  scoreType: ScoreType
  useForScoring: boolean
}

export const allScoreTypes = Object.values(ScoreType)

export const ExerciseScoreCategories = ["ALL", "MALE", "FEMALE"] as const
export type ExerciseScoreCategory = (typeof ExerciseScoreCategories)[number]
